<router-outlet />
<router-outlet name="popup" />
<router-outlet name="panel" />
